import { Box, Drawer, Grid, SwipeableDrawer } from '@mui/material'
import React, { useState } from 'react'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';

import globalStyles from "../../../../../../../assets/styles/global.module.scss";
import styles from '../../../../../../../assets/styles/componentStyles/templatemessages.module.scss'

import previewIcon from '../../../../../../../assets/chatbotAssets/Chatbot-Preview-Arrow.svg'
import { onClickOfFlowButton, replacingTemplateMarkdownText } from '../../../../../../../utils/constants';
import TemplatePreviewGlobal from './templatePreviewGlobal';
import { useSearchParams } from 'react-router-dom';
import { getSubButtonIcon, subButtonTypeIconMap } from '../../../../../templatelibrary/constant';
import { isInteractiveTypeMessageList, isInteractiveTypeMessageOrderDetails, shouldShowLimitedButtons, shouldShowLimitedButtonsSlice, shouldShowAllOptionsButton, shouldShowDrawerButtons, getAllTemplateButtons, shouldRenderBtnIcon, isTemplateTypeCallPermissionRequest } from '../utils';
import CallPermissionRequestPreview from '../../../../../templatelibrary/WhatsAppTemplatePreview/CallPermissionRequestPreview';

const BasicTemplatePreviewMobile = (props: any) => {
    const [openDrawer, setOpenDrawer] = useState(false);
    const [drawerOpen, setDrawerOpen] = useState(false);

    const [searchParams] = useSearchParams();
    let WabaID = searchParams.get("id");
    
    const isCallPermissionRequest = isTemplateTypeCallPermissionRequest(props.metaInformation?.whatsapp_template_type?.name);

    const toggleDrawer = (open: any) => (event: any) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerOpen(open);
    };

    const messageText = (type: string) => {
        let data, template: string = "";
        if (type.toLowerCase() === "body") {
            data = props.metaInformation.whatsapp_template_data?.whatsapp_template_body
            template = data?.whatsapp_template_body_value
            // Replacing placeholders with sample values
            data?.whatsapp_template_body_variable_data?.forEach((variable: any) => {
                const placeholder = variable.whatsapp_template_dynamic_variable_key
                const sampleValue = variable.whatsapp_template_dynamic_variable_sample_value;
                if (sampleValue) {
                    template = template?.replaceAll(placeholder, sampleValue);
                }
            });
        } else if (type.toLowerCase() === "header") {
            data = props.metaInformation.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data[0];
            template = data.whatsapp_template_header_data_value
            // Replacing placeholders with sample values
            data.whatsapp_template_header_variable_data?.forEach((variable: any) => {
                const placeholder = variable.whatsapp_template_dynamic_variable_key
                const sampleValue = variable.whatsapp_template_dynamic_variable_sample_value;
                if (sampleValue) {
                    template = template?.replaceAll(placeholder, sampleValue);
                }
            });
        } else {
            data = props.metaInformation.whatsapp_template_data?.whatsapp_template_footer;
            template = data?.whatsapp_template_footer_value || ""
        }

        // needed transformation
        return replacingTemplateMarkdownText(template);
    }

    const getSubButtonText = (subBtnData: any) => {
        let fieldVal = subBtnData.whatsapp_template_button_sub_type_field_data.filter((field: any) => field.field_name == "Button Text")[0]

        switch (fieldVal.field_static_value_flag) {
            case true:
                return fieldVal.field_static_value
            case false:
                return fieldVal.whatsapp_template_button_sub_type_field_value
            default:
                return ""
        }
    }


    const [open, setOpen] = React.useState(false);

    const toggleDrawer1 = (newOpen: any) => () => {
        setOpen(newOpen);
    };

    return (
        <>
            {/* PREVIEW */}
            <SwipeableDrawer
                anchor="right"
                open={props.openSwipableDrawer}
                onClose={toggleDrawer(false)}
                onOpen={toggleDrawer(true)}
                hideBackdrop={props.flagPositionRelative ? true : undefined}
                sx={props.flagPositionRelative ? {
                        position: "relative !important", 
                        zIndex: "1500 !important"
                    }
                    : undefined
                }
                PaperProps={{
                    className: styles.chatbotSwipeableDrawer,
                    style: {
                        overflow: 'auto',
                    },
                }}
            >
                <Grid item xs={12} id="test" className={styles.templatePreviewMainContainer}>
                    <Grid container alignItems={'center'} direction={"column"} className={styles.previewMainSection} gap={4}>
                        <Grid item paddingBlock={"10px"} style={{ width: "100%", textAlign: "center" }}>
                            <span className={styles.previewSectionTextStyle}> {props.flagCampaign ? "Preview" : "Preview Section"}</span>
                        </Grid>
                        <Grid item xs={12} sx={{ textAlign: "end", position: "absolute", right: "15px" }}>
                            <img
                                src={previewIcon}
                                style={{ width: "23px", height: "auto", objectFit: "fill", verticalAlign: "middle", transform: "rotate(180deg)" }}
                                alt=""
                                onClick={() => { props.setOpenSwipableDrawer(false) }}
                            />
                        </Grid>
                        
                        <Grid item>
                            <Grid container className={styles.previewCardColumn}>
                                
                                <Grid item padding={"0px"} className={styles.previewSectionCardBlock} sx={{ width: "100%", minWidth: "100% !important", maxWidth: "100% !important" }}>
                                    <Grid container direction={"column"} flexWrap={"nowrap"}>
                                        <TemplatePreviewGlobal 
                                            headerType={props.metaInformation?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_type_name}
                                            headerURL={props.metaInformation.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_data_value || props.metaInformation.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data[0]?.whatsapp_template_header_variable_data?.[0]?.whatsapp_template_dynamic_variable_sample_value}
                                            headerVaraibleData={props.metaInformation?.whatsapp_template_data?.whatsapp_template_header?.whatsapp_template_header_data?.[0]?.whatsapp_template_header_variable_data ?? []}
                                            isFooter={props.metaInformation?.whatsapp_template_data?.whatsapp_template_footer && props.metaInformation?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value && props.metaInformation?.whatsapp_template_data?.whatsapp_template_footer?.whatsapp_template_footer_value?.length > 0}
                                            headerText={messageText("header")}
                                            bodyText={messageText("body")}
                                            footerText={messageText("footer")}
                                        />

                                        {isInteractiveTypeMessageOrderDetails(props.metaInformation?.interactive_type_id, props?.interactiveTypeList ?? []) && // Order Details Interactive Type Message
                                            <Grid item padding={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}>
                                                <Grid container justifyContent={"center"} gap={1} alignItems={"center"} flexWrap={"nowrap"}>
                                                    <Grid item>
                                                        <Grid container direction={"column"}>
                                                            <Grid item>
                                                                {"Review and Pay"}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }

                                        {
                                            shouldShowLimitedButtons(props.metaInformation, props.interactiveTypeList) && getAllTemplateButtons(props.metaInformation).map((subBtnData: any, ind: number) => {
                                                return <React.Fragment key={ind}>
                                                    <Grid item paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`} onClick={() => onClickOfFlowButton(subBtnData, WabaID)}>
                                                        <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                                            {shouldRenderBtnIcon(props?.metaInformation, subBtnData?.whatsapp_template_button_sub_type_name) &&
                                                                <Grid item>
                                                                    {
                                                                        (subBtnData?.whatsapp_template_button_sub_type_name) 
                                                                        ? subButtonTypeIconMap[subBtnData?.whatsapp_template_button_sub_type_name?.toLowerCase() as keyof typeof subButtonTypeIconMap]
                                                                        : (props?.whatsappTemplateButtonGenericData && getSubButtonIcon(subBtnData?.whatsapp_template_button_sub_type_id, props?.whatsappTemplateButtonGenericData))
                                                                    }
                                                                </Grid>
                                                            }
                                                            <Grid item>
                                                                {getSubButtonText(subBtnData)}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </React.Fragment>
                                            })
                                        }
                                        {
                                            shouldShowLimitedButtonsSlice(props.metaInformation, props.interactiveTypeList) && getAllTemplateButtons(props.metaInformation).slice(0, 2).map((subBtnData: any, ind: number) => {
                                                return <React.Fragment key={ind}>
                                                    <Grid item paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`} onClick={() => onClickOfFlowButton(subBtnData, WabaID)}>
                                                        <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                                            {shouldRenderBtnIcon(props?.metaInformation, subBtnData?.whatsapp_template_button_sub_type_name) &&
                                                                <Grid item>
                                                                    {
                                                                        (subBtnData?.whatsapp_template_button_sub_type_name) 
                                                                        ? subButtonTypeIconMap[subBtnData?.whatsapp_template_button_sub_type_name?.toLowerCase() as keyof typeof subButtonTypeIconMap]
                                                                        : (props?.whatsappTemplateButtonGenericData && getSubButtonIcon(subBtnData?.whatsapp_template_button_sub_type_id, props?.whatsappTemplateButtonGenericData))
                                                                    }
                                                                </Grid>
                                                            }
                                                            <Grid item>
                                                                {getSubButtonText(subBtnData)}
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </React.Fragment>
                                            })
                                        }
                                        { shouldShowAllOptionsButton(props.metaInformation, props.interactiveTypeList) &&
                                            <Grid item paddingBlock={"12px"} className={`${styles.templatePreviewButtonItem} ${styles.templatePreviewButtonItemBorder}`}
                                                // onClick={() => setDrawerOpen(true)}
                                                onClick={toggleDrawer1(true)}
                                            >
                                                <Grid container justifyContent={"center"} gap={1} alignItems={"center"}>
                                                    <Grid item>
                                                        <MenuIcon style={{ display: "flex" }} />
                                                    </Grid>
                                                    <Grid item>
                                                        {isInteractiveTypeMessageList(props.metaInformation?.interactive_type_id, props?.interactiveTypeList ?? []) ? props.metaInformation?.interactive_list_button_text : "See All Options"}
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        }
                                    </Grid>
                                </Grid>

                                {isCallPermissionRequest && (
                                    <Grid item className={globalStyles.fullwidth} >
                                        <CallPermissionRequestPreview wabaName={props.wabaName} fullWidth variant="primary" />
                                    </Grid>
                                )}

                            </Grid>
                        </Grid>

                        <Grid item className={styles.drawerContainerStyle} style={{ display: openDrawer ? "block" : "none" }} xs={12}>
                            <CloseIcon className={styles.closeIconStyle} onClick={() => setOpenDrawer(false)} />
                            <Grid container direction={"column"} gap={"12px"}>
                                <Grid item xs={12} className={styles.drawerContainerBoxStyle}>
                                    <span className={styles.allOptionTextStyle}>{isInteractiveTypeMessageList(props.metaInformation?.interactive_type_id, props?.interactiveTypeList ?? []) ? props.metaInformation?.interactive_list_button_text : "All Options"}</span>
                                </Grid>
                                <Grid item xs={12} className={styles.drawerContainerBoxStyle}>
                                    <Box className={styles.drawerContainerBoxDetail}></Box>
                                </Grid>
                            </Grid>
                            {
                                shouldShowDrawerButtons(props.metaInformation) && getAllTemplateButtons(props.metaInformation)?.map((subBtnData: any, ind: number) => {
                                    return <React.Fragment key={ind}>
                                        <Grid item paddingBlock={"12px"} className={styles.templatePreviewButtonItem} onClick={() => onClickOfFlowButton(subBtnData, WabaID)}>
                                            <Grid container justifyContent={"start"} gap={2} alignItems={"center"}>
                                                {shouldRenderBtnIcon(props?.metaInformation, subBtnData?.whatsapp_template_button_sub_type_name) &&
                                                    <Grid item>
                                                        {
                                                            (subBtnData?.whatsapp_template_button_sub_type_name) 
                                                            ? subButtonTypeIconMap[subBtnData?.whatsapp_template_button_sub_type_name?.toLowerCase() as keyof typeof subButtonTypeIconMap]
                                                            : (props?.whatsappTemplateButtonGenericData && getSubButtonIcon(subBtnData?.whatsapp_template_button_sub_type_id, props?.whatsappTemplateButtonGenericData))
                                                        }
                                                    </Grid>
                                                }
                                                <Grid item>
                                                    {getSubButtonText(subBtnData)}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </React.Fragment>
                                })
                            }
                        </Grid>

                        <Drawer
                            open={open}
                            anchor='bottom'
                            onClose={toggleDrawer1(false)}
                            variant="temporary"
                            ModalProps={{
                                container: document.getElementById('test'),
                                disableEnforceFocus: true,
                                style: { position: 'absolute' },
                                keepMounted: false,
                            }}
                            sx={{
                                transition: open ? 'opacity 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'opacity 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                            }}
                            PaperProps={{ style: { position: "absolute", width: "100%" } }}
                            BackdropProps={{ style: { position: "absolute" } }}
                            SlideProps={{
                                direction: open ? "up" : "down",
                                timeout: { enter: 0, exit: 0 },
                                style: {
                                    borderRadius: "32px 32px 0px 0px",
                                    border: "2px solid #FAF0F0",
                                    padding: "15px",
                                    transition: open ? 'all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms' : 'all 275ms cubic-bezier(0.4, 0, 0.2, 1) 0ms'
                                }
                            }}
                        >
                            <Grid container direction={"column"} gap={"18px"} marginBottom={"15px"}>
                                <Grid item xs={12} className={styles.drawerContainerBoxStyle}>
                                    <Box className={styles.drawerContainerBoxDetail}></Box>
                                </Grid>
                                <Grid item xs={12} className={styles.drawerContainerBoxStyle}>
                                    <CloseIcon className={styles.closeDrawerIconStyle} onClick={() => setOpen(false)} />
                                    <span className={styles.allOptionTextStyle}>
                                        {isInteractiveTypeMessageList(props.metaInformation?.interactive_type_id, props?.interactiveTypeList ?? []) ? props.metaInformation?.interactive_list_button_text : "All Options"}
                                    </span>
                                </Grid>
                            </Grid>
                            {
                                shouldShowDrawerButtons(props.metaInformation) && getAllTemplateButtons(props.metaInformation)?.map((subBtnData: any, ind: number) => {
                                    return <Grid container key={ind}>
                                        <Grid item paddingBlock={"10px"} className={styles.templatePreviewButtonItem} onClick={() => onClickOfFlowButton(subBtnData, WabaID)}>
                                            <Grid container justifyContent={"start"} gap={2} alignItems={"center"}>
                                                {shouldRenderBtnIcon(props?.metaInformation, subBtnData?.whatsapp_template_button_sub_type_name) &&
                                                    <Grid item>
                                                        {
                                                            (subBtnData?.whatsapp_template_button_sub_type_name) 
                                                            ? subButtonTypeIconMap[subBtnData?.whatsapp_template_button_sub_type_name?.toLowerCase() as keyof typeof subButtonTypeIconMap]
                                                            : (props?.whatsappTemplateButtonGenericData && getSubButtonIcon(subBtnData?.whatsapp_template_button_sub_type_id, props?.whatsappTemplateButtonGenericData))
                                                        }
                                                    </Grid>
                                                }
                                                <Grid item>
                                                    {getSubButtonText(subBtnData)}
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                })
                            }
                        </Drawer>

                    </Grid>
                </Grid>
            </SwipeableDrawer>
        </>
    )
}

export default BasicTemplatePreviewMobile
